import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#ffb500',
    secondary: '#4f2c1d',
    accent: '#ffb500',
    info: '#000000',
  }
})
